/* unplugin-vue-components disabled */const { computed, nextTick } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-71eef997"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "item-start" };
const _hoisted_2 = { class: "not-point item-start" };
const _hoisted_3 = { class: "is-save item-start" };
const _hoisted_4 = { class: "is-unsave item-start" };
const _hoisted_5 = {
    key: 0,
    class: "io-input"
};
const _hoisted_6 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "信号口", -1));
const _hoisted_7 = {
    key: 1,
    class: "add-btn-wrap"
};
const _hoisted_8 = {
    key: 0,
    class: "state-wrap"
};
const model_1 = require("@/model");
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeleteBtn/index.vue"));
const work_1 = require("@/store/modules/work");
const data_operator_1 = require("@/utils/data_operator");
const index_vue_2 = tslib_1.__importDefault(require("@/components/IoInput/index.vue"));
const snowflake_1 = require("@/utils/snowflake");
const laborer_1 = require("@/store/modules/laborer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'FeedBin',
    props: {
        feedBin: {},
        mode: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const workStore = (0, work_1.useWork)();
        const laborerStore = (0, laborer_1.useLaborer)();
        const points = computed(() => props.feedBin.points);
        const curRobot = computed(() => { var _a; return (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.robot; });
        const snowflake = new snowflake_1.SnowflakeIdGenerate();
        const isActive = (index) => {
            var _a, _b;
            if (((_a = laborerStore.pointState) === null || _a === void 0 ? void 0 : _a.path.id) === props.feedBin.id && ((_b = laborerStore.pointState) === null || _b === void 0 ? void 0 : _b.pointIndex) === index) {
                return true;
            }
            else {
                return false;
            }
        };
        const itemState = (index) => {
            if (index == null)
                return 'notPoint';
            let point = points.value[index];
            let count = 0;
            for (const i of point) {
                if (i === 0)
                    count++;
            }
            if (count >= point.length)
                return 'unsave';
            else
                return 'saved';
        };
        const addPoint = (mode = 'down') => {
            var _a;
            let path = props.feedBin;
            let point = [0, 0, 0, 0, 0, 0];
            if (path.type === 'route' && path.ioId) {
                if (laborerStore.pointState == null || ((_a = laborerStore.pointState) === null || _a === void 0 ? void 0 : _a.pointIndex) >= laborerStore.pointState.path.points.length - 3) {
                    if (mode === 'down') {
                        path.points.splice(path.points.length - 3, 0, point);
                        laborerStore.selectPoint(path, path.points.length - 4);
                    }
                }
                else if (laborerStore.pointState.pointIndex < laborerStore.pointState.path.points.length - 3) {
                    if (mode === 'up') {
                        path.points.splice(laborerStore.pointState.pointIndex, 0, point);
                        laborerStore.selectPoint(path, laborerStore.pointState.pointIndex);
                    }
                    else if (mode === 'down') {
                        path.points.splice(laborerStore.pointState.pointIndex + 1, 0, point);
                        laborerStore.selectPoint(path, laborerStore.pointState.pointIndex + 1);
                    }
                }
            }
            if ((path.type === 'route' && !path.ioId) || path.type === 'joints') {
                if (path.type === 'joints') {
                    point = [0, 0, 0, 0, 0, 0, 0, 0];
                }
                if (laborerStore.pointState == null) {
                    path.points.push(point);
                    laborerStore.selectPoint(path, path.points.length - 1);
                }
                else {
                    if (mode === 'up') {
                        path.points.splice(laborerStore.pointState.pointIndex, 0, point);
                        laborerStore.selectPoint(path, laborerStore.pointState.pointIndex);
                    }
                    else if (mode === 'down') {
                        path.points.splice(laborerStore.pointState.pointIndex + 1, 0, point);
                        laborerStore.selectPoint(path, laborerStore.pointState.pointIndex + 1);
                    }
                }
            }
        };
        const handleNodeClick = (data) => {
            if (!['point', 'defaultPoint', 'singlePoint'].includes(data.type))
                return;
            data.id = snowflake.generate();
            laborerStore.selectPoint(props.feedBin, data.index);
        };
        const onDelPoint = (index) => {
            data_operator_1.RobotPathOperator.delPoint(props.feedBin, index, 1);
            laborerStore.selectPoint();
        };
        const onDelFeedBin = () => {
            var _a;
            (_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.delPath(props.feedBin.id);
        };
        const data = computed(() => {
            if (props.mode === 'feedBin') {
                return [
                    {
                        id: snowflake.generate(),
                        icon: "laborer-feed-bin",
                        label: props.feedBin.name,
                        type: 'feedBin',
                        state: 'notPoint',
                        children: [
                            {
                                id: snowflake.generate(),
                                icon: "laborer-route",
                                label: '料仓路径点',
                                type: 'path',
                                state: 'notPoint',
                                children: points.value.filter((point, index, arr) => index < arr.length - 3).map((point, index) => {
                                    return {
                                        id: snowflake.generate(),
                                        icon: "laborer-pose",
                                        label: `点${index}`,
                                        type: 'point',
                                        index,
                                        state: itemState(index), animationClass: '',
                                    };
                                }),
                            },
                            {
                                id: snowflake.generate(),
                                icon: "laborer-pose",
                                label: '取料上方点',
                                type: 'defaultPoint',
                                index: points.value.length - 3,
                                state: itemState(points.value.length - 3),
                                animationClass: ''
                            },
                            {
                                id: snowflake.generate(),
                                icon: "laborer-pose",
                                label: '取料点',
                                type: 'defaultPoint',
                                index: points.value.length - 2,
                                state: itemState(points.value.length - 2),
                                animationClass: ''
                            },
                            {
                                id: snowflake.generate(),
                                icon: "laborer-pose",
                                label: '料仓底部点',
                                type: 'defaultPoint',
                                index: points.value.length - 1,
                                state: itemState(points.value.length - 1),
                                animationClass: ''
                            }
                        ],
                    }
                ];
            }
            else if (props.mode === 'path') {
                return [
                    {
                        id: snowflake.generate(),
                        icon: props.feedBin.type === "joints" ? "laborer-joints" : "laborer-route",
                        label: props.feedBin.name,
                        type: 'path',
                        state: 'notPoint',
                        children: points.value.map((point, index) => {
                            return {
                                id: snowflake.generate(),
                                icon: props.feedBin.type === "joints" ? "laborer-joint" : "laborer-pose",
                                label: `点${index}`,
                                type: 'point',
                                index,
                                state: itemState(index),
                                animationClass: ''
                            };
                        }),
                    },
                ];
            }
            else if (props.mode === 'point') {
                return [
                    {
                        id: snowflake.generate(),
                        icon: props.feedBin.type === "joints" ? "laborer-joint" : props.feedBin.type === 'coord' ? 'laborer-coord' : 'laborer-pose',
                        label: props.feedBin.name,
                        type: 'singlePoint',
                        index: 0,
                        state: itemState(0),
                        animationClass: ''
                    }
                ];
            }
            else {
                throw new Error(`${props.mode} is illegal`);
            }
        });
        const playSaveAnimate = (index) => {
            let item;
            if (props.mode === 'feedBin') {
                let chiles = data.value[0].children[0].children;
                if (index >= chiles.length) {
                    item = data.value[0].children[index - chiles.length + 1];
                }
                else {
                    item = chiles[index];
                }
            }
            else if (props.mode === 'path') {
                item = data.value[0].children[index];
            }
            else if (props.mode === 'point') {
                item = data.value[0];
            }
            item.animationClass = 'animate__animated animate__pulse animate__faster';
            nextTick(() => {
                item.animationClass = '';
                item.id = snowflake.generate();
            });
        };
        __expose({
            playSaveAnimate
        });
        const defaultProps = {
            children: 'children',
            label: 'label',
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = (0, vue_2.resolveComponent)("svg-icon");
            const _component_Plus = (0, vue_2.resolveComponent)("Plus");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_EditPen = (0, vue_2.resolveComponent)("EditPen");
            const _component_SuccessFilled = (0, vue_2.resolveComponent)("SuccessFilled");
            const _component_WarningFilled = (0, vue_2.resolveComponent)("WarningFilled");
            const _component_el_tree = (0, vue_2.resolveComponent)("el-tree");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createVNode)(_component_el_tree, {
                    data: (0, vue_2.unref)(data),
                    props: defaultProps,
                    onNodeClick: handleNodeClick,
                    "default-expand-all": "",
                    "node-key": "id"
                }, {
                    default: (0, vue_2.withCtx)(({ node, data }) => {
                        var _a, _b, _c, _d;
                        return [
                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                class: (0, vue_2.normalizeClass)(["tree-item", { 'is-active': isActive(data.index), [data.animationClass]: data.animationClass !== '' }]),
                                key: data.id
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_2, null, 512), [
                                        [vue_2.vShow, data.state === 'notPoint']
                                    ]),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_3, null, 512), [
                                        [vue_2.vShow, data.state === 'saved']
                                    ]),
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", _hoisted_4, null, 512), [
                                        [vue_2.vShow, data.state === 'unsave']
                                    ])
                                ]),
                                (0, vue_2.createVNode)(_component_svg_icon, {
                                    "icon-class": data.icon,
                                    class: "path-icon"
                                }, null, 8, ["icon-class"]),
                                (0, vue_2.createElementVNode)("span", {
                                    class: (0, vue_2.normalizeClass)(["item-name", { 'bold': ['feedBin', 'path', 'singlePoint'].includes(data.type) }])
                                }, (0, vue_2.toDisplayString)(node.label), 3),
                                (data.type === 'feedBin')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                        _hoisted_6,
                                        (0, vue_2.createVNode)(index_vue_2.default, {
                                            model: ((0, vue_2.unref)(curRobot).code.getIOById(_ctx.feedBin.ioId) || {}).name,
                                            "onUpdate:model": _cache[0] || (_cache[0] = ($event) => ((((0, vue_2.unref)(curRobot).code.getIOById(_ctx.feedBin.ioId) || {}).name) = $event)),
                                            item: (0, vue_2.unref)(curRobot).code.getIOById(_ctx.feedBin.ioId)
                                        }, null, 8, ["model", "item"])
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (data.type === 'point' && isActive(data.index))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            circle: "",
                                            size: "small",
                                            type: "primary",
                                            class: "up-add-btn",
                                            onClick: _cache[1] || (_cache[1] = (0, vue_2.withModifiers)(($event) => (addPoint('up')), ["stop"]))
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, { size: "15" }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_Plus)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        (0, vue_2.createVNode)(_component_el_button, {
                                            circle: "",
                                            size: "small",
                                            type: "primary",
                                            class: "down-add-btn",
                                            onClick: _cache[2] || (_cache[2] = (0, vue_2.withModifiers)(($event) => (addPoint('down')), ["stop"]))
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createVNode)(_component_el_icon, { size: "15" }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(_component_Plus)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", {
                                    class: "icon-wrap",
                                    onClick: _cache[3] || (_cache[3] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                }, [
                                    (['defaultPoint', 'point', 'singlePoint'].includes(data.type))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                                            (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_icon, { color: "#7A7CBF" }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_EditPen)
                                                ]),
                                                _: 2
                                            }, 1536), [
                                                [vue_2.vShow, ((_b = (_a = (0, vue_2.unref)(laborerStore).pointState) === null || _a === void 0 ? void 0 : _a.editedState) === null || _b === void 0 ? void 0 : _b.path.id) === _ctx.feedBin.id && ((_d = (_c = (0, vue_2.unref)(laborerStore).pointState) === null || _c === void 0 ? void 0 : _c.editedState) === null || _d === void 0 ? void 0 : _d.pointIndex) === data.index]
                                            ]),
                                            (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_icon, {
                                                size: "15",
                                                color: "#00B900"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_SuccessFilled)
                                                ]),
                                                _: 2
                                            }, 1536), [
                                                [vue_2.vShow, data.state === 'saved']
                                            ]),
                                            (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_icon, {
                                                size: "15",
                                                color: "#FDCA40"
                                            }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createVNode)(_component_WarningFilled)
                                                ]),
                                                _: 2
                                            }, 1536), [
                                                [vue_2.vShow, data.state === 'unsave']
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createVNode)(index_vue_1.default, {
                                        class: "icon-wrap",
                                        unvisibility: data.type !== 'point' && data.type !== 'feedBin',
                                        title: `确定删除该'${data.label}'吗？`,
                                        onDelConfirm: ($event) => (data.type === 'feedBin' ? onDelFeedBin() : onDelPoint(data.index))
                                    }, null, 8, ["unvisibility", "title", "onDelConfirm"])
                                ]),
                                (data.type === 'path')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_button, {
                                        key: 2,
                                        icon: "Plus",
                                        onClick: _cache[4] || (_cache[4] = (0, vue_2.withModifiers)(($event) => (addPoint()), ["stop"])),
                                        round: "",
                                        class: "add-point-btn"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("添加点")
                                        ]),
                                        _: 1
                                    }))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ], 2))
                        ];
                    }),
                    _: 1
                }, 8, ["data"])
            ]));
        };
    }
});
